import { Input, Radio, Select, Switch } from "antd";
import React, { useEffect, useRef, useState } from "react";

import styles from "./phoneNumbers.scss";
import { homePhonePrefixes, mobilePhonePrefixes } from "../../models";
import { getIconUrl } from "../../services/asset";
import { Icon } from "antd";
import confirmModal from "../../services/confirmModal";

const PhoneInput = ({
  phone,
  legalEntity,
  handleAddPhoneNumber,
  handleUpdatePhoneNumber,
  handleSetPrimaryPhoneNumber,
  handleRemovePhoneNumber,
  verifyPhoneNumber,
  isDisabledCheckbox,
  isFormPage,
  isOnlyItem,
  isAdminRoute,
  error,
  autoFocus = false
}) => {
  const [value, setValue] = useState(phone ? phone.number : "");
  const [entityName, setEntityName] = useState(legalEntity && phone && phone.name ? phone.name : null);
  const [prefix, setPrefix] = useState(mobilePhonePrefixes[0]);
  const [isForeignNumber, setIsForeignNumber] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const inputRef = useRef(null);
  let isEditUserInfo = (isFormPage && phone && !phone.isVerified);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const OTHER_PHONE_TYPE = "other";
  const MOBILE_PHONE_TYPE = "mobile";



  useEffect(() => {
    if (legalEntity) {
      if (phone && phone.name) {
        setEntityName(phone.name);
      }
    } else {
      setEntityName(null);
    }
  }, [legalEntity]);

  const handleInputChange = (e) => {
    setValue(e.target.value);
    setIsDirty(true);
  };

  const handleEntityInputChange = (e) => {
    setEntityName(e.target.value);
    setIsDirty(true);
  };

  const handlePrefixChange = (value) => {
    setPrefix(value);
  };


  const handleSaveNumber = (e) => {
    e.preventDefault();

    if (value.trim()) {
      setValue(value);
      setIsDirty(false);

      if (prefix && !isForeignNumber) {
        const fullPhone = prefix + value.toString();

        handleAddPhoneNumber(fullPhone, isForeignNumber, entityName, (success) => {
          if (success) {
            setValue(fullPhone);
          }
        });
      } else {
        handleAddPhoneNumber(value, isForeignNumber, entityName);
      }
    } else {
      console.error("value of the number is not defined");
    }
  };

  const handleUpdateNumber = (e) => {
    e.preventDefault();
    if (!phone.id) return;

    setIsDirty(false);
    handleUpdatePhoneNumber(
      phone.id,
      value,
      isForeignNumber,
      entityName,
      phone.isPrimary,
    );
  };

  const handleVerifyNumberModal = (e) => {
    e.preventDefault();
    if (!phone) return;

    //if(!phone.isVerified) {
    //  check weather it's a mobile or home phone
    const isMobilePhone = mobilePhonePrefixes.find((prefix) =>
      phone.number.startsWith(prefix)
    );

    // send user a code
    if (isMobilePhone) {
      verifyPhoneNumber(MOBILE_PHONE_TYPE, phone);
    }
    // send to admin
    else {
      verifyPhoneNumber(OTHER_PHONE_TYPE, phone);
    }

  };

  const handleForeignNumberChange = (e) => {
    if (isForeignNumber) {
      setIsForeignNumber(false);
    } else {
      confirmModal.show({
        title: "Unosite broj telefona izvan Hrvatske",
        iconType: "NaN",
        width: 610,
        onOk() {
          setIsForeignNumber(true);
        },
        cancelText: "Odustani",
        okText: "Nastavi",
        children: (
          <React.Fragment>
            Ova opcija je namijenjena samo za telefonske brojeve koji nisu u hrvatskim mobilnim mrežama. Ako imate hrvatski broj, nemojte označavati ovu opciju.
          </React.Fragment>
        ),

      });
    }
  }

  return (
    <div className={`${styles.inputWrapper} ${isEditUserInfo ? styles.editUserInfo : ""}`}>
      {/* adding a new phone number  */}
      {!phone && (
        <div className={styles.switchContainer}>
          <Switch
            title="primary-phone"
            defaultChecked={false}
            checked={isForeignNumber}
            onChange={handleForeignNumberChange}
          />
          <span className={styles.foreignNumber}>
            {"Inozemni broj"}
          </span>
        </div>
      )}


      <Input.Group className={`
        ${styles.inputGroup} ${!phone ? styles.newPhone : ""} 
        ${((!phone && legalEntity) || (phone && phone.name)) ? styles.legalEntity : ""}
        `}>
        <div className={styles.groupNumber}>
          {/*  Foreign number */}
          {!isForeignNumber && !phone && (
            <Select
              onChange={handlePrefixChange}
              value={prefix}
              className={styles.select}
            >
              {mobilePhonePrefixes.map((prefix) => (
                <Select.Option key={prefix} value={prefix}>
                  {prefix}
                </Select.Option>
              ))}
              {homePhonePrefixes.map((prefix) => (
                <Select.Option key={prefix} value={prefix}>
                  {prefix}
                </Select.Option>
              ))}

            </Select>
          )}

          {/*  isPrimary or additional number */}
          {phone && phone.isVerified && !isFormPage && !isOnlyItem && (
            <Radio
              checked={phone && phone.isPrimary}
              disabled={isDisabledCheckbox}
              onChange={() =>
                handleSetPrimaryPhoneNumber(
                  phone.id,
                )
              }
              name="isPrimary"
              className={styles.radioLabel}
            >
              <span className={styles.text}>
                {phone.isPrimary ? "Primarni broj" : "Dodatni broj"}
              </span>
            </Radio>
          )}

          {/* number */}
          <div className={styles.numberContainer}>
            {isFormPage && phone && !isEditUserInfo && (
              <span className={`control-title  ${styles.label}`}>
                {phone.isPrimary || (isFormPage && isOnlyItem) ? "Primarni broj" : "Dodatni broj"}
              </span>
            )}
            {
              phone && (
                <Input className={`${styles.inputNumber} ${phone && !isEditUserInfo ? styles.readInput : ""}`}
                  onChange={handleInputChange}
                  value={phone.isVerified ? phone.number : value}
                  size="small"
                  required
                  readOnly={phone && phone.isVerified}
                  type={phone.isForeignNumber ? "text" : "number"}
                />
              )
            }
            {!phone && (
              <Input className={`${styles.inputNumber} ${phone && !isEditUserInfo ? styles.readInput : ""}`}
                onChange={handleInputChange}
                value={value}
                size="small"
                type={isForeignNumber ? "text" : "number"}
                required
                placeholder={isForeignNumber ? "Npr. +38755123456 ili 0038755123456" : "Npr. 123456"}
                readOnly={phone && phone.isVerified}
                ref={inputRef}
              />
            )}
          </div>
        </div>




        <div className={styles.actions}>
          {/* new legal entity name */}
          {legalEntity && !phone && (
            <Input
              className={styles.inputName}
              onChange={handleEntityInputChange}
              value={entityName}
              size="small"
              type="text"
              placeholder={"Ime i prezime (opciono)"}
            />
          )}
          {/* saved  entity name */}
          {legalEntity && phone && phone.name && (
            <Input
              className={`${styles.inputName} ${!isEditUserInfo ? styles.readInput : ""}`}
              onChange={handleEntityInputChange}
              value={phone.name}
              size="small"
              type="text"
              placeholder={"Ime i prezime (opciono)"}
              readOnly={phone && phone.isVerified}
            />
          )}


          {/* IF phone is saved */}
          {phone && !isDirty && !phone.isVerified && !isFormPage && (
            <button
              onClick={handleVerifyNumberModal}
              className={styles.actionBtn}
              aria-label="Verify-number"
            >
              {"Verificiraj broj"}
            </button>
          )}

          {/* IF phone is saved */}
          {phone && !phone.isVerified && isFormPage && (
            <button
              onClick={handleVerifyNumberModal}
              className={styles.actionBtn}
              aria-label="Verify-number"
            >
              {"Verificiraj broj"}
            </button>
          )}

          {phone && phone.isVerified && (
            <img
              className={styles.verifyBadge}
              src={getIconUrl("verified.svg")}
              alt="verified-badge"
            />
          )}

          {phone && ((!phone.isPrimary && !isFormPage) || (!isOnlyItem && isFormPage) || isAdminRoute) && (
            <button
              className={styles.deleteIcon}
              aria-label="delete-number"
              onClick={(e) => handleRemovePhoneNumber(e, phone)}
            >
              <Icon type="delete" />
            </button>
          )}


          {/* IF phone is not yet saved */}
          {!phone && (
            <button
              className={styles.actionBtn}
              aria-label="Save-number"
              onClick={handleSaveNumber}
              disabled={
                (isForeignNumber && value.length == 0) || (!isForeignNumber && (value.length < 6 || value.length > 7))
              }
            >
              {"Spremi"}
            </button>
          )}

          {/* If we are updating the existing phone*/}
          {isDirty && phone && !phone.isVerified && (
            <button
              className={styles.actionBtn}
              aria-label="update-number"
              onClick={handleUpdateNumber}
              disabled={
                (phone.isForeignNumber && value.length == 0) || (!phone.isForeignNumber && (value.length < 9 || value.length > 10))
              }
            >
              {"Spremi"}
            </button>
          )}
        </div>
      </Input.Group>
    </div>
  );
};

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/components/PhoneNumbers/PhoneInput.tsx